export default __webpack_public_path__ + "static/media/logo.282fd023.png";